import styles from './Form.module.css';

import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { PageHeader, Card, Spin, Button, Tooltip, Tag, Tabs, Descriptions, Popconfirm } from 'antd';
import moment from 'moment';

import {
  ReloadOutlined, UndoOutlined
} from '@ant-design/icons';

import {
  getForm, clearForm, deleteForm, undeleteAllFormSubmissions, copyToQsAccount
} from 'store/ducks/forms.js';

const Form = ({ match }) => {
  const dispatch = useDispatch();

  const formId = match.params.id;
  const form = useSelector(state => state.forms.form);
  const getFormLoading = useSelector(state => state.forms.getForm.loading);
  const copyToQsAccountLoading = useSelector(state => state.forms.copyToQsAccount.loading);

  const loading = getFormLoading || copyToQsAccountLoading;

  const reload = () => dispatch(getForm(formId));
  const handleDelete = () => dispatch(deleteForm(formId)).then(() => window.history.back());
  const handleUndeleteAllFormSubmissions = () => dispatch(undeleteAllFormSubmissions(formId)).then(() => reload());
  const handleCopyToQsAccount = () => dispatch(copyToQsAccount(formId)).then((res) => {
    window.location.href = `/forms/${res.payload._id}`;
  });

  useEffect(() => {
    dispatch(getForm(formId));

    return () => {
      dispatch(clearForm());
    };
  }, []);

  return (
    <>
      <Spin spinning={loading} size="large">
        <div style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0', minHeight: 80 }}>
          {form && <PageHeader
            title={form.name || '[undefined]'}
            onBack={() => window.history.back()}
            extra={[
              <Popconfirm key="duplicate"
                placement="bottomRight"
                title={'Are you sure?'}
                onConfirm={() => handleCopyToQsAccount()}
                okText="Yes, duplicate"
                cancelText="No">
                <Button type="dashed">Copy to QS account</Button>
              </Popconfirm>,
              <Button type="primary" ghost key="preview" href={`https://form.questionscout.com/${form._id}-${form.previewToken}?qs__ghost=true`} target="_blank">Open</Button>,
              <Popconfirm key="delete"
                placement="bottomRight"
                title={'Are you 100% sure?'}
                onConfirm={() => handleDelete()}
                okText="Yes, delete"
                cancelText="No">
                <Button danger>Delete</Button>
              </Popconfirm>,
              <Button key="reload" onClick={() => reload()}><ReloadOutlined /></Button>
            ]}>
            <Descriptions size="small" column={3}>
              <Descriptions.Item label="Owner">
                <Link to={`/users/${form.owner._id}`}>{form.owner.email}</Link>
              </Descriptions.Item>
              <Descriptions.Item label="Created At">{moment(form.createdAt).format('DD.MM.YYYY HH:mm')}</Descriptions.Item>
              <Descriptions.Item label="Updated At">{moment(form.updatedAt).format('DD.MM.YYYY HH:mm')}</Descriptions.Item>
              <Descriptions.Item label="Staus">
                {form.status === 'live' && <Tag color="green">{form.status}</Tag>}
                {form.status === 'paused' && <Tag color="orange">{form.status}</Tag>}
              </Descriptions.Item>
              <Descriptions.Item label="Type">{form.type}</Descriptions.Item>
            </Descriptions>
          </ PageHeader>}
        </div>
      </Spin>

      <Spin spinning={loading} size="large">
        <Card style={{ width: '100%', minHeight: 224 }}>
          <Tabs animated={false}>
            <Tabs.TabPane tab="General" key="general">
              {form && <Descriptions layout="vertical" bordered>
                <Descriptions.Item label="ID">{form._id}</Descriptions.Item>
                <Descriptions.Item label="Theme Type">{form.themeType}</Descriptions.Item>
                <Descriptions.Item label="Theme ID">{form.themeId}</Descriptions.Item>
                <Descriptions.Item label="Respondent Limits">{form.respondentLimits}</Descriptions.Item>
                <Descriptions.Item label="Respondent Limits Number">{form.respondentLimitsNumber}</Descriptions.Item>
                <Descriptions.Item label="Notifications Email">{form.notificationsEmail}</Descriptions.Item>
                <Descriptions.Item label="Notifications Email Number">{form.notificationsEmailNumber}</Descriptions.Item>
                <Descriptions.Item label="Confirmation Email">{form.confirmationEmail}</Descriptions.Item>
                <Descriptions.Item label="Confirmation Email Field">{form.confirmationEmailField}</Descriptions.Item>
                <Descriptions.Item label="Fields Number">{form.fields.length}</Descriptions.Item>
                <Descriptions.Item label="Web Hooks Number">{form.webHooks.length}</Descriptions.Item>
                <Descriptions.Item label="Zapier Hooks Number">{form.zapierHooks.length}</Descriptions.Item>
                <Descriptions.Item label="Url Params Number">{form.urlParams.length}</Descriptions.Item>
              </Descriptions>}
            </Tabs.TabPane>

            <Tabs.TabPane tab="Responses" key="responses">
              {form && <Descriptions layout="horizontal" bordered>
                <Descriptions.Item label="Responses">{form.responsesCount}</Descriptions.Item>
                <Descriptions.Item label="Deleted Responses">
                  {form.deletedResponsesCount}
                  <Button icon={<UndoOutlined />} shape="circle" style={{ margin: '0 0 0 10px' }} onClick={handleUndeleteAllFormSubmissions}></Button>
                </Descriptions.Item>
              </Descriptions>}
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </Spin>
    </>
  );
}

export default withRouter(Form);
